import { createFileRoute } from '@tanstack/react-router'
import { WebLayout } from '@/components/layout'
import { BlogPage } from '@/features/blog'

export const Route = createFileRoute('/blog/')({
  component: BlogPageRoute,
})

function BlogPageRoute() {
  return (
    <WebLayout>
      <BlogPage />
    </WebLayout>
  )
}
